import { isEmpty, trim } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component, Fragment } from 'react'
import FormGroup from 'components/form_group'
import { FieldError } from 'entities/error'
import { propTypeInstantiableTo } from 'supports/custom_prop_types'

export default class IntroductionForm extends Component {
  constructor(props) {
    super(props)
    const error = new Error()
    error.fieldErrors = props.errors.map(e => new FieldError(e.field, e.message))

    this.state = {
      error,
      introduction: null
    }
  }

  handleChangeTextarea(value) {
    this.setState({
      introduction: trim(value)
    })
  }

  render() {
    const { name } = this.props
    const { error, introduction } = this.state

    return (
      <Fragment>
        <FormGroup error={error} name="introduction">
          <label htmlFor="applicant_introduction" className="form-group-label">
            {I18n.t('introductions.new.form.invitation.label', { name })}
          </label>
          <div className="form-group-content">
            <textarea
              className="form-control"
              id="applicant_introduction"
              name="applicant[introduction]"
              placeholder={I18n.t('introductions.new.form.invitation.placeholder')}
              rows="10"
              onChange={e => this.handleChangeTextarea(e.target.value)}
            />
          </div>
        </FormGroup>
        <div className="card-actions">
          <input
            type="submit"
            className="btn btn-submit btn-raised"
            value={I18n.t('introductions.new.form.button.send')}
            data-disable-with={I18n.t('introductions.new.form.button.send')}
            disabled={isEmpty(introduction)}
          />
        </div>
      </Fragment>
    )
  }
}

IntroductionForm.propTypes = {
  errors: PropTypes.arrayOf(propTypeInstantiableTo(FieldError)),
  name: PropTypes.string.isRequired
}

IntroductionForm.defaultProps = {
  errors: []
}
